module.exports = __webpack_public_path__ + "img/members_icon@2x.44a7a15c.png";